// Type,Name,Client Id,Id,Parent Id,Brand Id
// Format Version,6,,,,
// Brand List,<brand list name>,0-0-0,-1,,,,
// Brand Item,,0-0-0-0-0,,-1,<brandid1>

export const BrandList = {
  parent: 'Account',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Brand List',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    Name: {
      'bulk-upload-header': 'Name',
    },
    ParentId: {
      'bulk-upload-header': 'Parent ID',
    },
    ClientId: {
      'bulk-upload-header': 'Client Id',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
  },
};
